import "./App.css";
import React from "react";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import HowItWorks from "./components/HowItWorks";
import WhoItsFor from "./components/WhoItsFor";
import Results from "./components/Results";
import MemberResults from "./components/MemberResults";
import FAQ from "./components/FAQ";
import RequestInfo from "./components/RequestInfo";
import Footer from "./components/Footer";

function App() {
  return (
    <div className="App bg-[#0a0908]">
      <Navbar />
      <main>
        <Hero />
        <HowItWorks />
        <WhoItsFor />
        <Results />
        <MemberResults />
        <FAQ />
        <RequestInfo />
      </main>
      <Footer />
    </div>
  );
}

export default App;
